<template>
  <b-container class="modal-page d-flex justify-content-center">
    <change-email-form
      class="modal__card"
      v-if="currentRoute === 'email'"
    ></change-email-form>
    <change-phone-form
      class="modal__card"
      v-else-if="currentRoute === 'phone'"
    ></change-phone-form>
    <change-password-form
      class="modal__card"
      v-else-if="currentRoute === 'password'"
    ></change-password-form>
    <delete-account-form class="verify__card" v-else></delete-account-form>
  </b-container>
</template>
<script>
/**
 * ==================================================================================
 * Change page
 * ==================================================================================
 **/

import ChangeEmailForm from '@/components/forms/ChangeEmailForm'
import ChangePhoneForm from '@/components/forms/ChangePhoneForm'
import ChangePasswordForm from '@/components/forms/ChangePasswordForm'
import DeleteAccountForm from '@/components/forms/DeleteAccountForm'

export default {
  components: {
    ChangeEmailForm,
    ChangePhoneForm,
    ChangePasswordForm,
    DeleteAccountForm
  },
  metaInfo: function() {
    let title = null
    switch (this.currentRoute) {
      case 'delete':
        title = 'Delete Account'
        break
      default:
        title = `Change ${this.currentRoute}`
        break
    }

    return {
      title: title
    }
  },
  computed: {
    currentRoute() {
      return this.$route.params.field
    }
  }
}
</script>
